module.exports = __webpack_public_path__ + "img/score_9.8cffcf52.png";